import * as React from 'react'
import { LandingPagesLayout } from '../../shared/components/LandingPagesLayout'
import { Hero } from './components/Hero';
import { StateList } from './components/StateList';
import { Breadcrumbs } from '../../shared/components/Breadcrumbs';
import { FlexibleWork } from '../../shared/components/FlexibleWork';
import { BecomeAShopper } from '../../shared/components/BecomeAShopper';
import { createSignupLink } from '../../shared/utils/SignupForm';

export const ShopperJobs = () => {
  const {
    landingPageStrings,
    currentHost,
    topCities,
    privacyChoicesEnabled,
    locale,
    defaultCountry,
    currentCountry,
    nearmeFormAction,
    jobsPageStrings,
    availableCountries,
    countryPlaceholders,
    shopperJobsUrl,
    signupUrl,
    states,
    sendAppLinkUrl
  } = window.gon
  const countryCopy = currentCountry !== 'us' ? 'Canada' : 'the United States'

  return (
    <LandingPagesLayout
      signupLink={() => createSignupLink(currentHost)}
      footerContent={landingPageStrings.footer}
      currentHost={currentHost}
      currentCountry={currentCountry}
      locale={locale}
      topCities={topCities}
      privacyChoicesEnabled={privacyChoicesEnabled}
      className="lg:max-w-full"
    >
      <Hero
        locale={locale}
        defaultCountry={defaultCountry}
        nearmeFormAction={nearmeFormAction}
        title={jobsPageStrings.hero.title}
        subtitle={jobsPageStrings.hero.subtitle}
        alt={jobsPageStrings.hero.alt}
        availableCountries={availableCountries}
        countryPlaceholders={countryPlaceholders}
      />
      <div className="bg-kale px-7 xl:px-0">
        <Breadcrumbs
          navLinks={[
            { text: jobsPageStrings.breadcrumbs.signup, url: signupUrl },
            {
              text: jobsPageStrings.breadcrumbs.shopperJobs,
              url: shopperJobsUrl,
            },
          ]}
        />
        <FlexibleWork
          title={jobsPageStrings.flexibleWork.title.replace(/%{location}/, countryCopy)}
          body={jobsPageStrings.flexibleWork.description}
          landingPageStrings={landingPageStrings}
          sendAppLinkUrl={sendAppLinkUrl}
        />
      </div>
      <StateList
        states={states}
        seeMoreText={jobsPageStrings.stateInfo.showMore}
        seeAllText={jobsPageStrings.stateInfo.showMore}
        title={jobsPageStrings.stateInfo.title.landingPages}
        description={jobsPageStrings.stateInfo.description}
      />
      <div className="bg-kale-dark px-7 xl:px-0">
        <BecomeAShopper
          title={jobsPageStrings.becomeAShopper.title}
          subtitle={jobsPageStrings.becomeAShopper.subtitle}
          cta={jobsPageStrings.becomeAShopper.cta}
          signupUrl={signupUrl}
        />
      </div>
    </LandingPagesLayout>
  )
}
